
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/thread",
      function () {
        return require("private-next-pages/community/thread/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/thread"])
      });
    }
  